import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { RoutingEventsService } from '@mri-platform/shared/core';
import { LoadingComponent } from '@mri-platform/shared/core-ui';
import { asapScheduler, Observable } from 'rxjs';
import { observeOn } from 'rxjs/operators';

@Component({
  selector: 'mri-shared-page-loading',
  template: ` <mri-shared-loading [show]="pageLoading$ | async"></mri-shared-loading> `,
  imports: [LoadingComponent, AsyncPipe],
  standalone: true
})
export class PageLoadingComponent {
  pageLoading$: Observable<boolean> = this.routerEvents.isNavigationPending$.pipe(
    // avoid change detection fail by listening at end of current event loop
    observeOn(asapScheduler)
  );
  constructor(private routerEvents: RoutingEventsService) {}
}
